export default "__VITE_ASSET__$r4Ng1om__"